import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

// Linked removal may cascade to an eligible partner, so it must be confirmed.
export function needsLeftoverRemoveConfirm(leftoverRole) {
  return leftoverRole === 'cook' || leftoverRole === 'leftover';
}

/**
 * LEFTOVERS: linked dinner<->lunch pair removal confirmation, shared by Plan
 * and Browse & Choose. `pending` is { planId, mealName, role } or null;
 * `onConfirm(pending)` performs the existing conditional-cascade delete.
 */
export default function LeftoverRemoveDialog({ pending, onCancel, onConfirm }) {
  return (
    <AlertDialog open={pending !== null && pending !== undefined} onOpenChange={function(open) { if (!open) onCancel(); }}>
      <AlertDialogContent data-testid="leftover-remove-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Remove linked meals?</AlertDialogTitle>
          <AlertDialogDescription>
            This dinner and its next-day leftover lunch are cooked together as one batch.
            Removing {pending ? pending.mealName : 'this meal'} also removes its linked partner
            only if that partner is still pending and dated today or later. Logged, finalized,
            legacy-planned, and past-dated partners are kept. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={function() {
              if (pending) onConfirm(pending);
              onCancel();
            }}
            className="bg-red-500 hover:bg-red-600"
            data-testid="confirm-leftover-remove-btn"
          >
            Remove meal
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
